import { useState } from 'react';

type Props = Record<'criticalInfo' | 'positiveInfo' | 'negativeInfo', string[]>;

export const useInfoItems = ({ criticalInfo, positiveInfo, negativeInfo }: Props) => {
	const [criticalItems, setCriticalItems] = useState(criticalInfo);
	const [positiveItems, setPositiveItems] = useState(positiveInfo);
	const [negativeItems, setNegativeItems] = useState(negativeInfo);

	const itemsChanged =
		criticalItems !== criticalInfo ||
		positiveItems !== positiveInfo ||
		negativeItems !== negativeInfo;

	return {
		criticalItems,
		positiveItems,
		negativeItems,
		setCriticalItems,
		setPositiveItems,
		setNegativeItems,
		itemsChanged,
	};
};
